import {
  getSnapshot,
  IDisposer,
  IModelType,
  ModelProperties,
  onSnapshot,
  types,
} from 'mobx-state-tree'
import { useMemo } from 'react'

export function useReviewModel<T extends ModelProperties>(
  document: any,
  group: string,
  identifier: string,
  model: IModelType<T, any> | null = null,
  title: string | null = null,
) {
  const content = useMemo(() => {
    try {
      const item = document?.data.get(group)?.get(identifier, true)
      return (item && getSnapshot<any>(item).content) || {}
    } catch {
      return {}
    }
  }, [document, group, identifier])

  const dataModel = useMemo(() => {
    const actions = (self) => {
      let snapshotDisposer: IDisposer
      const afterCreate = () => {
        snapshotDisposer = onSnapshot(self, (snapshot) => {
          document?.setData(
            identifier,
            snapshot,
            title,
            group,
            undefined,
            !!self.filled,
          )
        })
      }
      const beforeDestroy = () => {
        snapshotDisposer()
      }
      return { afterCreate, beforeDestroy }
    }
    if (model === null)
      return types.model({}).actions(actions).named(`${group}.${identifier}`)
    return types
      .compose(model, types.model({}))
      .actions(actions)
      .named(`${group}.${identifier}`)
  }, [model, document, identifier, title, group])

  return useMemo(() => {
    try {
      return dataModel.create(content)
    } catch {
      return dataModel.create()
    }
  }, [dataModel, content])
}
